'use client'

import { useOutsideClick } from '@/lib/hooks'
import { Badge, Button } from 'flowbite-react'
import React, { useState } from 'react'

interface FreeDropdownProps {
  label: React.ReactNode
  children: React.ReactNode
  className?: string
}

const FreeDropdown = ({ label, children, className }: FreeDropdownProps) => {
  const [activeFilter, setActiveFilter] = useState(false)
  const ref = useOutsideClick(() => {
    setActiveFilter(false)
  })

  return (
    <div className="relative" ref={ref}>
      <Button
        type="button"
        color="light"
        onClick={() => setActiveFilter(!activeFilter)}
        className={className}
      >
        {label}
      </Button>
      {activeFilter && (
        <div className="absolute left-0 mt-2 z-10 shadow-lg">{children}</div>
      )}
    </div>
  )
}

export default FreeDropdown
